import React from 'react';

import {ScoresListHeaderModuleMobileDater} from "./scores-list-header-module.mobile-dater";
import {ScoresListHeaderModuleProps} from "../../models/scores-list-header-module.props";

export class ScoresListWidgetHeaderMobileComponentProps extends ScoresListHeaderModuleProps {}

export const ScoresListHeaderModuleMobile = ({controller, onDateChange}: ScoresListWidgetHeaderMobileComponentProps) => {

  return (
    <div className={'scores-list-header-module-mobile-container'}>
      <ScoresListHeaderModuleMobileDater controller={controller} onDateChange={onDateChange}/>
    </div>
  );
};
